export default __webpack_public_path__ + "static/media/lesson_flow001.d549eb5e.png";